// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activity_YwJwH {
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: flex-start;
  width: 100%;
  margin: 0 auto;
  min-height: fit-content;
  border-bottom: 1px solid var(--ececf1-border);
  /* padding-bottom: 20px; */
  cursor: pointer;
  gap: 10px;

  &:hover {
    background: var(--f5f5f538-background-hover);
    border-radius: 10px;
    transition: all .3s ease;

    .activityHeader_TlYEC {
      padding: 10px 0;

      height: auto !important;
    }
  }

  /* p {
    margin: 0;
  } */

  .activityTime_NQ8RB {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;

    .activityTimeLeft_KJwCv {
      background: var(--f5-background);
      display: flex;
      align-items: flex-start;
      gap: 10px;
      padding: 8px 10px 4px;
      height: 100%;
      min-width: 88px;

      b {
        font-size: 16px;
        font-weight: 600;
        color: var(--_18181b-color);
      }

      span {
        font-size: 12px;
        font-weight: 600;
        color: var(--_18181b-color);
      }
    }

    .activityTimeRight_Vwf0K {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-top: 6px;
      min-width: 70px;

      .dot_vigCo {
        width: 10px;
        height: 10px;
        min-width: 10px;
        min-height: 10px;
        border-radius: 50%;
        background-color: var(--_16c09821-background);
      }

      p {
        margin: 0;
        font-size: 10px;
        font-weight: 400;
        color: var(--_18181b-color);
      }
    }
  }

  .info_RS7S4 {
    display: flex;
    align-items: center;
    gap: 20px;

    img {
      width: 16px;
      height: 16px;
    }
  }

  /* .date {
    display: flex;
    width: 100%;
    justify-content: end;
    position: absolute;
    bottom: 5px;
    right: 20px;
    font-size: 13px;
    color: var(--_2-color);
    gap: 10px;
  } */
}

.circleUnseen_Udbiv {
  background-color: #dc3545;
  height: 15px;
  width: 15px;
  border-radius: 999px;
}

.activityContainer_tCP10{
  width: 100%;

  .options_R08VB {
    display: none;
    width: 100%;
    justify-content: end;
    gap: 10px;
    align-items: center;
    p {
      margin: 0 0 6px;
    }
  }
  .activityHeader_TlYEC {
    display: none;
    transition: height 0.3s ease;
    overflow: hidden;
    interpolate-size: allow-keywords;
    display: flex;
    justify-content: end;
    gap: 10px;
    margin-bottom: 14px;
    margin-top: 4px;
    margin-left: -50px;
  
    span {
      font-size: 12px;
      font-weight: 600;
      color: var(--7b7575-color);
      cursor: pointer;
      margin-left: auto;
    }
  }

  &:hover {
    .options_R08VB, .activityHeader_TlYEC {
      display: flex;
    }
  }
}


.notificationItem_m8RTJ {
  display: flex;
  gap: 10px;
  /* margin-left: 20px; */

  img {
    width: 16px;
    height: 16px;
  }

  p {
    font-size: 12px;
    font-weight: 400;
    color: var(--_18181b-color);
    margin: 0;
    opacity: 0.8;
  }
}

.activityHeaderDocument_TGwAj {
  flex-direction: column;
  position: relative;


}


.gray_zuOrr {
  color: var(--7b7575-color);
  font-weight: 600;
  cursor: pointer;
}

.green_Hl3FF,
.delete_vBI59 {
  color: var(--_084437-color);
  font-weight: 600;
  cursor: pointer;
  font-size: 12px;
  margin: 10px 0px;
}

.delete_vBI59 {
  color: rgb(253, 71, 71);
  text-decoration: underline;
}

.documentDate_MNmw5 {
  display: flex;
  width: 100%;
  justify-content: end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;

}

.documentHeader_UwIl0 {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .headerLeft_ATlEA {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--_18181b-color);
    margin-top: 4px;

    p {
      margin: 0;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.activityDefault_nnzsm {
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  width: 90%;
  margin: 0 auto;
  min-height: fit-content;
  border-bottom: 1px solid var(--ececf1-border);
  padding-bottom: 20px;
  cursor: pointer;


  p {
    margin: 0;
    color: var(--_71-color);
  }

  .info_RS7S4 {
    display: flex;
    align-items: center;
    gap: 20px;

    img {
      width: 16px;
      height: 16px;
    }
  }

  .date_ejDTw {
    display: flex;
    width: 100%;
    justify-content: end;
    position: absolute;
    bottom: 5px;
    right: 20px;
    font-size: 13px;
    color: var(--_2-color);
    gap: 10px;
  }
}

.p_Yr2MG {
  color: var(--black-color) !important;

  &:empty::after {
    content: "21:11 PM";
    color: transparent;
    font-size: 10px;
    font-style: italic;
    position: relative;
    transform: translate(-40px, -10px);
    background: linear-gradient(90deg, var(--f5-background) 0%, var(--white-background) 50%, var(--f5-background) 100%);
    background-size: 200% 100%;
    animation: wave_HKMvg 2s ease-in-out infinite;
    padding: 5px 8px;
    border-radius: 10px;
    z-index: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NotificationComponent/NotificationComponent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,6CAA6C;EAC7C,0BAA0B;EAC1B,eAAe;EACf,SAAS;;EAET;IACE,4CAA4C;IAC5C,mBAAmB;IACnB,wBAAwB;;IAExB;MACE,eAAe;;MAEf,uBAAuB;IACzB;EACF;;EAEA;;KAEG;;EAEH;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;;IAET;MACE,gCAAgC;MAChC,aAAa;MACb,uBAAuB;MACvB,SAAS;MACT,qBAAqB;MACrB,YAAY;MACZ,eAAe;;MAEf;QACE,eAAe;QACf,gBAAgB;QAChB,2BAA2B;MAC7B;;MAEA;QACE,eAAe;QACf,gBAAgB;QAChB,2BAA2B;MAC7B;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,eAAe;MACf,eAAe;;MAEf;QACE,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,6CAA6C;MAC/C;;MAEA;QACE,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,2BAA2B;MAC7B;IACF;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;;;;;;;;;;KAUG;AACL;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;;EAEX;IACE,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB;MACE,eAAe;IACjB;EACF;EACA;IACE,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;;IAElB;MACE,eAAe;MACf,gBAAgB;MAChB,0BAA0B;MAC1B,eAAe;MACf,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,aAAa;IACf;EACF;AACF;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;;EAEvB;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;IACT,YAAY;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;;;AAGpB;;;AAGA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,eAAe;;IAEf;MACE,SAAS;IACX;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,6CAA6C;EAC7C,oBAAoB;EACpB,eAAe;;;EAGf;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE,oCAAoC;;EAEpC;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,mHAAmH;IACnH,0BAA0B;IAC1B,6CAAuC;IACvC,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[".activity {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  justify-content: flex-start;\n  width: 100%;\n  margin: 0 auto;\n  min-height: fit-content;\n  border-bottom: 1px solid var(--ececf1-border);\n  /* padding-bottom: 20px; */\n  cursor: pointer;\n  gap: 10px;\n\n  &:hover {\n    background: var(--f5f5f538-background-hover);\n    border-radius: 10px;\n    transition: all .3s ease;\n\n    .activityHeader {\n      padding: 10px 0;\n\n      height: auto !important;\n    }\n  }\n\n  /* p {\n    margin: 0;\n  } */\n\n  .activityTime {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 10px;\n\n    .activityTimeLeft {\n      background: var(--f5-background);\n      display: flex;\n      align-items: flex-start;\n      gap: 10px;\n      padding: 8px 10px 4px;\n      height: 100%;\n      min-width: 88px;\n\n      b {\n        font-size: 16px;\n        font-weight: 600;\n        color: var(--_18181b-color);\n      }\n\n      span {\n        font-size: 12px;\n        font-weight: 600;\n        color: var(--_18181b-color);\n      }\n    }\n\n    .activityTimeRight {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      margin-top: 6px;\n      min-width: 70px;\n\n      .dot {\n        width: 10px;\n        height: 10px;\n        min-width: 10px;\n        min-height: 10px;\n        border-radius: 50%;\n        background-color: var(--_16c09821-background);\n      }\n\n      p {\n        margin: 0;\n        font-size: 10px;\n        font-weight: 400;\n        color: var(--_18181b-color);\n      }\n    }\n  }\n\n  .info {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n\n    img {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  /* .date {\n    display: flex;\n    width: 100%;\n    justify-content: end;\n    position: absolute;\n    bottom: 5px;\n    right: 20px;\n    font-size: 13px;\n    color: var(--_2-color);\n    gap: 10px;\n  } */\n}\n\n.circleUnseen {\n  background-color: #dc3545;\n  height: 15px;\n  width: 15px;\n  border-radius: 999px;\n}\n\n.activityContainer{\n  width: 100%;\n\n  .options {\n    display: none;\n    width: 100%;\n    justify-content: end;\n    gap: 10px;\n    align-items: center;\n    p {\n      margin: 0 0 6px;\n    }\n  }\n  .activityHeader {\n    display: none;\n    transition: height 0.3s ease;\n    overflow: hidden;\n    interpolate-size: allow-keywords;\n    display: flex;\n    justify-content: end;\n    gap: 10px;\n    margin-bottom: 14px;\n    margin-top: 4px;\n    margin-left: -50px;\n  \n    span {\n      font-size: 12px;\n      font-weight: 600;\n      color: var(--7b7575-color);\n      cursor: pointer;\n      margin-left: auto;\n    }\n  }\n\n  &:hover {\n    .options, .activityHeader {\n      display: flex;\n    }\n  }\n}\n\n\n.notificationItem {\n  display: flex;\n  gap: 10px;\n  /* margin-left: 20px; */\n\n  img {\n    width: 16px;\n    height: 16px;\n  }\n\n  p {\n    font-size: 12px;\n    font-weight: 400;\n    color: var(--_18181b-color);\n    margin: 0;\n    opacity: 0.8;\n  }\n}\n\n.activityHeaderDocument {\n  flex-direction: column;\n  position: relative;\n\n\n}\n\n\n.gray {\n  color: var(--7b7575-color);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.green,\n.delete {\n  color: var(--_084437-color);\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 12px;\n  margin: 10px 0px;\n}\n\n.delete {\n  color: rgb(253, 71, 71);\n  text-decoration: underline;\n}\n\n.documentDate {\n  display: flex;\n  width: 100%;\n  justify-content: end;\n  align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n\n}\n\n.documentHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .headerLeft {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: var(--_18181b-color);\n    margin-top: 4px;\n\n    p {\n      margin: 0;\n    }\n\n    img {\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n.activityDefault {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  justify-content: center;\n  width: 90%;\n  margin: 0 auto;\n  min-height: fit-content;\n  border-bottom: 1px solid var(--ececf1-border);\n  padding-bottom: 20px;\n  cursor: pointer;\n\n\n  p {\n    margin: 0;\n    color: var(--_71-color);\n  }\n\n  .info {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n\n    img {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  .date {\n    display: flex;\n    width: 100%;\n    justify-content: end;\n    position: absolute;\n    bottom: 5px;\n    right: 20px;\n    font-size: 13px;\n    color: var(--_2-color);\n    gap: 10px;\n  }\n}\n\n.p {\n  color: var(--black-color) !important;\n\n  &:empty::after {\n    content: \"21:11 PM\";\n    color: transparent;\n    font-size: 10px;\n    font-style: italic;\n    position: relative;\n    transform: translate(-40px, -10px);\n    background: linear-gradient(90deg, var(--f5-background) 0%, var(--white-background) 50%, var(--f5-background) 100%);\n    background-size: 200% 100%;\n    animation: wave 2s ease-in-out infinite;\n    padding: 5px 8px;\n    border-radius: 10px;\n    z-index: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activity": `activity_YwJwH`,
	"activityHeader": `activityHeader_TlYEC`,
	"activityTime": `activityTime_NQ8RB`,
	"activityTimeLeft": `activityTimeLeft_KJwCv`,
	"activityTimeRight": `activityTimeRight_Vwf0K`,
	"dot": `dot_vigCo`,
	"info": `info_RS7S4`,
	"circleUnseen": `circleUnseen_Udbiv`,
	"activityContainer": `activityContainer_tCP10`,
	"options": `options_R08VB`,
	"notificationItem": `notificationItem_m8RTJ`,
	"activityHeaderDocument": `activityHeaderDocument_TGwAj`,
	"gray": `gray_zuOrr`,
	"green": `green_Hl3FF`,
	"delete": `delete_vBI59`,
	"documentDate": `documentDate_MNmw5`,
	"documentHeader": `documentHeader_UwIl0`,
	"headerLeft": `headerLeft_ATlEA`,
	"activityDefault": `activityDefault_nnzsm`,
	"date": `date_ejDTw`,
	"p": `p_Yr2MG`,
	"wave": `wave_HKMvg`
};
export default ___CSS_LOADER_EXPORT___;
